// extracted by mini-css-extract-plugin
export default {"ul":"Navbar-Nav_ul__4X4QB","icons":"Navbar-Nav_icons__rteUZ","list":"Navbar-Nav_list__-FQKk"};